import { createSelector } from 'reselect';

export const productDetailsAttributeSelector = createSelector(
  (state) => state.product,
  (product) => product.details.attributes,

);
